<template>
    <div>
        <az-call-to-action dark
                           :active="propostaResumo.podeEnviar"
                           :outline="!propostaResumo.podeEnviar"
                           @click="verificarDocumentosHabilitacaoProposta"
                           class="no-mobile">
            Enviar Propostas
        </az-call-to-action>
        <!--confirmacao envio da proposta -->
        <az-confirm v-if="mostrarConfirmacaoEnviarProposta" :maxWidth=320
                    @onConfirm="confirmarEnvioProposta" @onDecline="fecharConfirmacaoEnviarProposta">
            Deseja realmente enviar a proposta?
        </az-confirm>
      <modal-confirm v-if="mostrarModalAlertaSemDocumentos" :maxWidth=450
                  labelDecline="ENVIAR MESMO ASSIM" label-confirm="VOLTAR PARA ANEXAR" :showDecline="exibirEnviarMesmoAssim"
                  @onConfirm="verificarDocumentos" @onDecline="fecharModalAnexoDocumentos">
        <div class="texto-modal-habilitacao">
          <v-icon color="#FFD22D">warning</v-icon>
          <label>
            Identificamos que não existem documentos de
            <template v-if="alertaDocsProposta"> proposta</template>
            <template v-if="alertaDocsHabilitacao && alertaDocsProposta"> e</template>
            <template v-if="alertaDocsHabilitacao"> habilitação</template>
            anexados à sua proposta, certifique-se das exigências do edital do processo
            quanto a documentação.
          </label>
        </div>
      </modal-confirm>
        <!--protocolo gerado-->
        <az-dialog v-if="mostrarDialogProtocolo" @ok="finalizarEnvio()">
            <wrapper-dialog>
                <div class="dialog-sucesso">
                    <span class="dialog-title">Proposta enviada com sucesso</span><br/>
                    <span class="dialog-text">Protocolo gerado: {{protocoloGerado.numero}}</span>
                </div>
            </wrapper-dialog>
        </az-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {actionTypes, mutationTypes, tiposLicitacao} from '@/commons/constants'
    import WrapperDialog from '@/commons/components/WrapperDialog'
    import validadorProposta from '../proposta/licitacao-fornecedor-proposta-validador'
    import _ from "lodash";
    import ModalConfirm from "@/commons/components/ModalConfirm.vue";

    export default {
        props: {
          moedaSelecionadaId: {
            type: Number,
            default: null,
          },
          dataReferencia: {
            type: String,
            default: null,
          }
        },
        name: 'LicitacaoFornecedorAcoesEnviar',
        components: {ModalConfirm, WrapperDialog},
        component: {
            WrapperDialog
        },
        data() {
            return {
                globalLoadingAtivado: false,
                mostrarConfirmacaoEnviarProposta: false,
                mostrarDialogProtocolo: false,
                protocoloGerado: {},
                documentos: [],
                mostrarModalAlertaSemDocumentos: false,
                alertaDocsHabilitacao: false,
                alertaDocsProposta: false
            }
        },
        computed: {
            isMenorPreco() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
            },
            ehModalidadeLeilao() {
                return this.licitacao && this.licitacao.modalidade && this.licitacao.modalidade.includes('LEILÃO')
            },
            isMelhorTecnica() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MTC
            },
            ehModoManual(){
              return this.parametros.propriedadesLicitacao.modoCriacaoProcesso === 'MANUAL'
            },
            exibirEnviarMesmoAssim(){
                return !this.licitacao.inversaoFases
            },
            ...mapState(['licitacao', 'loki', 'propostaResumo', 'parametros', 'licitacaoPropostaItens'])
        },
        methods: {
            abrirDialogProtocolo() {
                this.mostrarDialogProtocolo = true
            },
            async confirmarEnvioProposta() {
                this.fecharConfirmacaoEnviarProposta()
                if (this.isMelhorTecnica && !this.propostaResumo.possuiPropostas) {
                    this.mostrarNotificacaoErro('Deve-se SALVAR a proposta para depois realizar o envio.')
                    return
                }
                if (!this.propostaResumo.licitacaoAbertaParaPropostas) {
                    this.mostrarNotificacaoErro('Não foi possível realizar o envio, pois está fora do período de envio de propostas.')
                    return
                }
                this.habilitarLoading()
                try {
                    let planoFornecedor = await this.buscarDadosAssinaturasFornecedor()
                    if (!planoFornecedor.assinaturaAtual) {
                        this.mostrarNotificacaoErro('Plano expirado, não foi possível efetuar o envio de propostas.')
                        return
                    }
                    const isPropostaValida = await this.isPropostaComItensValidosParaEnvio()
                    if (!isPropostaValida) {
                        this.atualizarObjetosItensProposta()
                        this.mostrarNotificacaoErro('Não foi possível realizar o envio da proposta pois existem itens com preenchimento incompleto.')
                        return
                    }
                    if(this.licitacao.status !== 'AGUARDANDO_ABERTURA'){
                      this.mostrarNotificacaoErro('Só é possível efetuar propostas em licitações com o status "Aguardando Abertura".')
                      return
                    }
                    await this.efetuarEnvioProposta()
                    this.abrirDialogProtocolo()
                    this.desabilitarLoading()
                } catch (e) {
                    this.desabilitarLoading()
                }
            },
            atualizarObjetosItensProposta() {
              const novaListaItens = _.concat(this.licitacaoPropostaItens)
              this.$store.commit(mutationTypes.SET_LICITACAO_PROPOSTA_ITENS, _.cloneDeep(novaListaItens))
            },
            desabilitarLoading() {
                if (!this.globalLoadingAtivado) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async efetuarEnvioProposta() {
                let idMoedaEstrangeira = this.retornarIdMoedaEstrangeira()
                this.setMensagemLoading('Enviando proposta...')
                this.protocoloGerado = await this.enviarProposta({licitacaoId: this.licitacao.id, idMoedaEstrangeira})
                this.$emit('atualizarProposta')
            },
          retornarIdMoedaEstrangeira() {
              if(this.licitacao.moedaSelecionada !== undefined) {
                return this.licitacao.moedaSelecionada.id
              }

              return undefined
            },
            fecharConfirmacaoEnviarProposta() {
                this.mostrarConfirmacaoEnviarProposta = false
            },
            fecharDialogProtocolo() {
                this.mostrarDialogProtocolo = false
            },
            async finalizarEnvio() {
                this.habilitarLoading()
                try {
                    await this.sincronizarProposta()
                    this.fecharDialogProtocolo()
                    this.desabilitarLoading()
                } catch (e) {
                    this.fecharDialogProtocolo()
                    this.desabilitarLoading()
                }
            },
            habilitarLoading() {
                this.globalLoadingAtivado = this.loki.isGlobalLoadingEnabled
                this.habilitarLoadingGlobal()
            },
            async isPropostaComItensValidosParaEnvio() {
                return validadorProposta.validar(this.licitacaoPropostaItens, this.isMenorPreco, this.ehAmparoLei14133Art82(), this.ehModalidadeLeilao)
            },
            async sincronizarProposta() {
                this.setMensagemLoading('Carregando dados da Proposta...')
                await this.buscarPropostaResumo(this.licitacao.id)
            },
            async verificarDocumentosHabilitacaoProposta(){
              await this.buscarDocumentos()
              const docsHabilitacao = this.documentos.items.filter(doc => doc.tipoAnexo === 'ANEXO_HABILITACAO' && doc.tipoDocumento === 'OUTROS')
              const docsProposta = this.documentos.items.filter(doc => doc.tipoAnexo === 'ANEXO_PROPOSTA')
              this.alertaDocsHabilitacao = docsHabilitacao.length === 0
              this.alertaDocsProposta = !this.ehModoManual && (docsProposta.length === 0 || docsProposta.length === 1 && docsProposta[0].tipoDocumento === 'ACEITE_TERMOS')
              if(this.licitacao.inversaoFases && this.alertaDocsHabilitacao){
                this.mostrarModalAlertaSemDocumentos = true
              }else if(!this.licitacao.inversaoFases && (this.alertaDocsHabilitacao || this.alertaDocsProposta)){
                this.mostrarModalAlertaSemDocumentos = true
              }else{
                this.mostrarConfirmacaoEnviarProposta = true
              }
            },
            fecharModalAnexoDocumentos(){
              this.mostrarModalAlertaSemDocumentos = false
              this.mostrarConfirmacaoEnviarProposta = true
            },
            verificarDocumentos(){
              if(this.$route.name !== 'licitacaoFornecedorDocumentos'){
                this.$router.push({name: 'licitacaoFornecedorDocumentos', params: {id: this.licitacao.id}})
              }
              this.mostrarModalAlertaSemDocumentos = false
              this.mostrarConfirmacaoEnviarProposta = false
            },
            async buscarDocumentos() {
              this.documentos = await this.buscarDocumentosProposta(this.licitacao.id)
            },
            temAmparoLei14133Incluso() {
              const amparoLegal = this.licitacao.amparoLegal
              return amparoLegal && /^Lei 14\.133\/2021, Art\. \d+\,/.test(amparoLegal.lei);
            },
            ehAmparoLei14133Art82() {
              return this.licitacao.amparoLegal && this.licitacao.amparoLegal.lei === 'Lei 14.133/2021, Art. 82, IV'
            },
            ...mapActions([
                actionTypes.BUSCAR_DOCUMENTOS_PROPOSTA,
                actionTypes.BUSCAR_PROPOSTA_RESUMO,
                actionTypes.BUSCAR_LICITACAO_PROPOSTA_ITENS,
                actionTypes.ENVIAR_PROPOSTA,
                actionTypes.BUSCAR_DADOS_ASSINATURAS_FORNECEDOR,
                actionTypes.BUSCAR_TERMOS
            ])
        }
    }
</script>

<style lang="stylus" scoped>

.texto-modal-habilitacao
    text-align justify

</style>
